var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcellentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0C3.46875 0 0 3.46875 0 7.75C0 12.0312 3.46875 15.5 7.75 15.5C12.0312 15.5 15.5 12.0312 15.5 7.75C15.5 3.46875 12.0312 0 7.75 0ZM10.25 5.25C10.8031 5.25 11.25 5.69688 11.25 6.25C11.25 6.80312 10.8031 7.25 10.25 7.25C9.69687 7.25 9.25 6.80312 9.25 6.25C9.25 5.69688 9.69687 5.25 10.25 5.25ZM5.25 5.25C5.80312 5.25 6.25 5.69688 6.25 6.25C6.25 6.80312 5.80312 7.25 5.25 7.25C4.69688 7.25 4.25 6.80312 4.25 6.25C4.25 5.69688 4.69688 5.25 5.25 5.25ZM11.3375 10.5688C10.4469 11.6375 9.14062 12.25 7.75 12.25C6.35938 12.25 5.05312 11.6375 4.1625 10.5688C3.7375 10.0594 4.50625 9.42188 4.93125 9.92813C5.63125 10.7688 6.65625 11.2469 7.75 11.2469C8.84375 11.2469 9.86875 10.7656 10.5688 9.92813C10.9875 9.42188 11.7594 10.0594 11.3375 10.5688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellentIcon);
export default __webpack_public_path__ + "static/media/excellent_icon.e9f345f8da3d44dfaa02c4c048a0731b.svg";
export { ForwardRef as ReactComponent };